export default __webpack_public_path__ + "static/media/loster.0536d184.png";